<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange" :options="timeOptions" :value='searchConf.searchTime'
                          @on-change='timeChange' format="yyyy-MM-dd"
                          :placeholder="$t('选择时间')" style="width: 200px">
              </DatePicker>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.type' clearable
                                                      :placeholder="$t('操作') " style='width:120px'>
              <Option :value="'0'">{{ $t('指定会员') }}</Option>
              <Option :value="'1'">{{ $t('指定等级') }}</Option>
              <Option :value="'2'">{{ $t('全部用户') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'gameManage/LuckyTask/add'" @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="120"
            label-position="left">
        <FormItem label='操作类型' prop='type'>
          <Select clearable v-model='windowAddItem.type' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('指定会员') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('指定等级') }}</Option>
            <Option :value="'2'" :key='2'>{{ $t('全部用户') }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="windowAddItem.type=='0'&&windowAddItem.id==0" label='生效用户名' prop='usernames'>
          <Input type="textarea" clearable v-model='windowAddItem.usernames' :placeholder="$t('支持多个用户名，以逗号隔开')"></Input>
        </FormItem>


        <FormItem v-if="windowAddItem.type=='1'" label='生效等级' prop='grade'>
          <Select clearable v-model='windowAddItem.grade' style='width:200px'>
            <Option :key="key" :value="value.grade_key.toString()"
                    v-for="(value, key) in extraParams"> {{ value.grade_name }}
            </Option>
          </Select>
        </FormItem>


        <FormItem label='日期' prop='on_day'>
          <!--          <Input clearable v-model='windowAddItem.on_day' :placeholder="$t('请输入日期')"></Input>-->
          <DatePicker type="date" :value='windowAddItem.on_day'
                      format="yyyy-MM-dd" @on-change='timeChange2'
                      :placeholder="$t('选择时间')" style="width: 200px">
          </DatePicker>
        </FormItem>
        <FormItem label='商品最低价格' prop='min_price'>
          <Input number clearable v-model='windowAddItem.min_price' :placeholder="$t('请输入商品最低价格')"></Input>
        </FormItem>
        <FormItem label='商品最高价格' prop='max_price'>
          <Input number clearable v-model='windowAddItem.max_price' :placeholder="$t('请输入商品最高价格')"></Input>
        </FormItem>
        <FormItem label='佣金系数%' prop='commission'>
          <Input clearable v-model='windowAddItem.commission_rate' :placeholder="$t('请输入佣金系数%')"></Input>
        </FormItem>
        <FormItem label='超时时间(小时)' prop='lucky_delay'>
          <Input clearable v-model='windowAddItem.lucky_delay' :placeholder="$t('超时时间(小时),超时后可继续做任务')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/gameManage/LuckyTask'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('操作类型'),
        key: 'type_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('用户名'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('商品最小价格'),
        key: 'min_price',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('商品最大价格'),
        key: 'max_price',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('佣金系数(%)'),
        key: 'commission_rate',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('生效日期'),
        key: 'on_day',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('生效等级'),
        key: 'grade_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      }],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        on_day: '',
        usernames: '',
        grade: '',
        lucky_delay:'',
        max_price:'',
        min_price:''
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('gameManage/LuckyTask/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('gameManage/LuckyTask/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('gameManage/LuckyTask/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getParams()
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
    },
    getParams () {
      getParams().then(response => {
        this.extraParams = response.data.data.gradeArray
      })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },

    timeChange2 (date) { //时间修改，自动计算尾部时间
      this.windowAddItem.on_day = date

    },

    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
